/**
 * A `Field`-based view which exports the attributes of a set of models into a read-only report of comma-separated values.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The array of models associated with the view.
 * fields | The array of `Field` models displayed by the view.
 * @module app/views/CSVView
 */
import Backbone from "backbone";
import _ from "underscore";
export default Backbone.View.extend({
  tagName: "textarea",
  className: "csv-view",

  attributes: {
    readonly: "readonly",
  },

  /**
   * Initializes the control
   * @param  {object} options The options hash.
   * @param {mixed} options.models The models to associate with the view.
   * @param {Array} options.fields The array of `Field` models to display in the view.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      models: [],
      fields: [],
    });

    this.models = this.options.models;
    this.fields = this.options.fields;
  },

  render: function () {
    var strValue = "";

    _.each(this.fields, function (field) {
      strValue += field.attributes.name + ",";
    });
    strValue += "\n";
    _.each(
      this.models,
      _.bind(function (model) {
        _.each(this.fields, function (field) {
          var fieldValue = field.getValue(model);

          if (field.hasValues()) {
            fieldValue = _.result(
              _.find(field.get("values"), function (value) {
                return value.value == fieldValue;
              }),
              "text"
            );
          }

          var val = fieldValue || "";

          strValue += val + ",";
        });
        strValue += "\n";
      }, this)
    );
    this.$el.val(strValue);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/CSVView.js
// module id = 908
// module chunks = 1